module.exports = __webpack_public_path__ + "static/pwc-whitepaper-bad1c32430a746a714ab442314a1147e.jpeg";